import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const SortAppliedEventSchema: EventSchema = {
  eventName: EN.SORT_APPLIED,
  params: {
    ...CommonEventProperties,
    BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
    EVENT_CATEGORY: EPK.EVENT_CATEGORY,
    STORE_ID_SAP: EPK.STORE_ID_SAP,
    STORE_ID_DBP: EPK.STORE_ID_DBP,
    SORT_CATEGORY: EPK.SORT_CATEGORY,
  },
}
